import React from 'react';
import { SuggestionCard } from './SuggestionCard';
import { useAuth } from '../../contexts/AuthContext';
// import { useAuth } from "../../hooks/chat/useAuth";
import { useSuggestions } from '../../hooks';
import { useChat } from '../../hooks';
import { ToolMode } from '../../constants/toolModes';

interface SuggestionGridProps {
  onSelect: (content: string, tools: ToolMode[]) => void;
  tools: ToolMode[];
}

export const SuggestionGrid: React.FC<SuggestionGridProps> = ({ onSelect, tools }) => {
  const { state: { user } } = useAuth();
  const {
    suggestions,
    loading,
    editing,
    setEditing,
    updateSuggestion
  } = useSuggestions();

  const { hasNewChat } = useChat();

  const handleSelect = async (content: string) => {
    // Only proceed if there isn't already a new chat in progress
    if (!hasNewChat) {
      onSelect(content, tools);
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 animate-pulse">
        {[...Array(4)].map((_, i) => (
          <div 
            key={i}
            className="h-24 bg-gray-100 dark:bg-gray-700 rounded-lg"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {suggestions.map((suggestion) => (
        <SuggestionCard
          key={suggestion.id}
          id={suggestion.id}
          content={suggestion.content}
          isEditing={editing === suggestion.id}
          onEdit={() => setEditing(suggestion.id)}
          onSave={(content) => updateSuggestion(suggestion.id, content)}
          onCancel={() => setEditing(null)}
          onClick={() => handleSelect(suggestion.content)}
        />
      ))}
    </div>
  );
};
